import type { Employee } from 'modules/core/hooks/useCurrentSession'

export const isManager = (employee: Employee) => {
  if (!employee) {
    return false
  }

  return employee.reports.length > 0
}
